module.exports = __webpack_public_path__ + "static/fonts/ionicons.d535a25.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/view-design/dist/styles/fonts/ionicons.ttf?v=3.0.0
// module id = t4J2
// module chunks = 101